const transformStyle = {
  name: "transform-style",
  path: "/transform-style",
  title: "transform-style",
  description: "Utilities for controlling the CSS transform-style property.",
  value: {
    "transform-style": {
      "transform-style-flat": "flat",
      "transform-style-3d": "preserve-3d"
    }
  },
  exampleData: [
    {
      example: {
        code: `<div class="size-20 transform-flat ...">
  <div class="translate-z-12 rotate-x-0 bg-color-sky-300/75 backface-hidden ...">1</div>
  <div class="-translate-z-12 rotate-y-18 bg-color-sky-300/75 backface-hidden ...">2</div>
  <div class="translate-x-12 rotate-y-90 bg-color-sky-300/75 backface-hidden ...">3</div>
  <div class="-translate-x-12 -rotate-y-90 bg-color-sky-300/75 backface-hidden ...">4</div>
  <div class="-translate-y-12 rotate-x-90 bg-color-sky-300/75 backface-hidden ...">5</div>
  <div class="translate-y-12 -rotate-x-90 bg-color-sky-300/75 backface-hidden ...">6</div>
</div>
<div class="size-20 transform-3d ...">
  <div class="translate-z-12 rotate-x-0 bg-color-sky-300/75 backface-visible ...">1</div>
  <div class="-translate-z-12 rotate-y-18 bg-color-sky-300/75 backface-visible ...">2</div>
  <div class="translate-x-12 rotate-y-90 bg-color-sky-300/75 backface-visible ...">3</div>
  <div class="-translate-x-12 -rotate-y-90 bg-color-sky-300/75 backface-visible ...">4</div>
  <div class="-translate-y-12 rotate-x-90 bg-color-sky-300/75 backface-visible ...">5</div>
  <div class="translate-y-12 -rotate-x-90 bg-color-sky-300/75 backface-visible ...">6</div>
</div>`
      }
    }
  ],
  htmlData: [
    {
      title: "Transform style",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">transform-style-3d</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">transform-style-flat</code> to set the <code>transform-style</code> property.
      </p>
      <div class="flex flex-col justify-around gap-8 text-sm leading-6 font-bold text-color-white sm:flex-row sm:gap-0">
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">transform-style-flat</p>
            <div class="size-40 p-10">
                <div class="size-20 rotate-[0.75_1_0.75_45deg] transform-style-flat">
                    <div class="absolute inset-0 translate-z-12 rotate-x-0 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 dark:bg-color-sky-400/85 dark:text-color-white">1</div>
                    <div class="absolute inset-0 -translate-z-12 rotate-y-180 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75 dark:bg-color-sky-400/85 dark:text-color-white">2</div>
                    <div class="absolute inset-0 translate-x-12 rotate-y-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75 dark:bg-color-sky-400/85 dark:text-color-white">3</div>
                    <div class="absolute inset-0 -translate-x-12 -rotate-y-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 dark:bg-color-sky-400/85 dark:text-color-white">4</div>
                    <div class="absolute inset-0 -translate-y-12 rotate-x-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75 dark:bg-color-sky-400/85 dark:text-color-white">5</div>
                    <div class="absolute inset-0 translate-y-12 -rotate-x-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 dark:bg-color-sky-400/85 dark:text-color-white">6</div>
                </div>
            </div>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">transform-style-3d</p>
            <div class="size-40 p-10">
                <div class="size-20 rotate-[0.75_1_0.75_45deg] transform-style-3d">
                    <div class="absolute inset-0 translate-z-12 rotate-x-0 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">1</div>
                    <div class="absolute inset-0 -translate-z-12 rotate-y-180 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">2</div>
                    <div class="absolute inset-0 translate-x-12 rotate-y-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">3</div>
                    <div class="absolute inset-0 -translate-x-12 -rotate-y-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">4</div>
                    <div class="absolute inset-0 -translate-y-12 rotate-x-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 opacity-75 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">5</div>
                    <div class="absolute inset-0 translate-y-12 -rotate-x-90 bg-color-sky-300/75 text-center text-4xl leading-20 font-bold text-color-sky-900 backface-visible dark:bg-color-sky-400/85 dark:text-color-white">6</div>
                </div>
            </div>
        </div>
        </div>
      `
    }
  ]
};

export default transformStyle;